/** @format */

// material
import { alpha, styled } from "@mui/material/styles";
import { Box, Card, Typography } from "@mui/material";
// utils
// import { fShortenNumber } from "../../utils/formatNumber";
// component
import Iconify from "../../components/Iconify";

// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: "none",
  textAlign: "center",
  padding: theme.spacing(3, 1),
  color: theme.palette.info.darker,
  backgroundColor: theme.palette.primary.lighter,
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
}));

const IconWrapperStyle = styled("div")(({ theme }) => ({
  margin: "auto",
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  width: theme.spacing(5),
  height: theme.spacing(5),
  marginBottom: theme.spacing(2),
  color: theme.palette.info.dark,
  backgroundImage: `linear-gradient(135deg, ${alpha(
    theme.palette.info.dark,
    0
  )} 0%, ${alpha(theme.palette.info.dark, 0.24)} 100%)`,
}));

// ----------------------------------------------------------------------

// const TOTAL = 3249;

export default function CardDashboard(props) {
  const { value, icon, title } = props;

  return (
    <RootStyle>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <IconWrapperStyle>
          <Iconify icon={icon} width={20} height={20} />
        </IconWrapperStyle>
        <Typography
          sx={{
            opacity: 0.72,
            fontSize: "12px",
            fontWeight: "bold",
            wordWrap: "break-word",
          }}
        >
          {title}
          {/* Total Business Initiated */}
        </Typography>
        <Typography variant="h4">{value}</Typography>
      </Box>
    </RootStyle>
  );
}
